import { useState } from "react";
import { ArrowRightLeft, Check } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const KIND_LABELS = { evaluation: "Evaluation", "client task": "Client task", placement: "Placement", task: "Task" };

export function HandoffBanner({ handoffs = [], onChanged, onError }) {
  const [busy, setBusy] = useState("");
  if (!handoffs.length) return null;
  async function acknowledge(handoff) {
    try {
      setBusy(handoff.id);
      await api.post(`/providers/me/handoffs/${handoff.id}/seen`);
      onChanged?.();
    } catch (requestError) {
      onError?.(formatApiError(requestError));
    } finally {
      setBusy("");
    }
  }
  return (
    <section className="provider-handoffs" data-testid="provider-handoffs">
      {handoffs.map((handoff) => (
        <article className={`provider-handoff ${handoff.seen_at ? "is-seen" : ""}`} key={handoff.id} data-testid={`provider-handoff-${handoff.id}`}>
          <ArrowRightLeft size={18} />
          <div>
            <h2 data-testid={`provider-handoff-title-${handoff.id}`}>New from {handoff.from_name}: {handoff.count} item{handoff.count === 1 ? "" : "s"}</h2>
            <p>{handoff.from_name}'s assignment at {handoff.client_name || "TAG"} ended ({handoff.reason_label}) on {handoff.created_at?.slice(0, 10)}. These now sit in your queue{handoff.students?.length ? ` · students ${handoff.students.join(", ")}` : ""}.</p>
            <ul>
              {handoff.items.map((item) => <li key={item.id}><em>{KIND_LABELS[item.kind] || item.kind}</em> {item.label}</li>)}
            </ul>
          </div>
          {!handoff.seen_at && <button className="button button-secondary" data-testid={`provider-handoff-seen-${handoff.id}`} type="button" disabled={busy === handoff.id} onClick={() => acknowledge(handoff)}><Check size={14} /> Got it</button>}
        </article>
      ))}
    </section>
  );
}
